<template>
  <div>
    <el-row :gutter="10" style="margin: 0px">
      <el-col :xs="6" :sm="7" :md="6" :lg="6" :xl="6">
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            padding: 5px 0;
          "
        >
          <img src="../../assets/logo7.png" height="50" width="194" />
        </div>
      </el-col>
      <el-col :span="10">
        <div style="display: flex; flex-direction: column">
          <el-menu
            :default-active="activeIndex"
            router
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="/home">首页</el-menu-item>
            <el-menu-item index="/introduction">实验简介</el-menu-item>
            <el-menu-item index="/team">团队介绍</el-menu-item>
            <el-menu-item index="/resource">资源中心</el-menu-item>
            <el-menu-item index="/hardware">硬件及网络要求</el-menu-item>
          </el-menu>
        </div>
      </el-col>
      <el-col :span="8">
        <div style="display: flex; align-items: center">
          <div style="width: 320px; color: #61646e">
            <div style="height: 20px">
              <span style="font-weight: 600"> QQ答疑群：</span>
              <span>828085734</span>
            </div>
            <div style="height: 20px">
              <span style="font-weight: 600"> 服务热线：</span>
              <span style="">400-829-8667 / 024-56860725</span>
            </div>
          </div>
          <div v-if="username" style="line-height: 60px">
            <span>{{ username }}</span>
            <a-divider type="vertical" style="margin: 0 10px" />
            <el-link @click="logoutsys">退出登录</el-link>
          </div>
          <div v-else>
            <el-link
              type="primary"
              @click="loginsys"
              style="line-height: 60px; width: 50px"
              >登录
            </el-link>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Menu",
  inject: ["reload"],
  data () {
    return {
      mtype: true,
      username: null,
      activeIndex: "/home",
    };
  },
  mounted () {
    this.activeIndex = this.$route.path;
    let userform = localStorage.getItem("userform");
    if (userform) {
      this.username = JSON.parse(userform).nickName;
      this.mtype = false;
    } else {
      this.mtype = true;
    }

    // window.localStorage.removeItem('username')
  },
  methods: {
    logoutsys () {
      this.username = "";
      this.$router.push("/");
      localStorage.clear();
      this.reload();
    },
    loginsys () {
      this.$root.$emit('onLoginShow');
    },
    handleSelect (key, keyPath) {
      this.activeIndex = key;
      localStorage.setItem("redirectNum", 'undefined');
    },
    toRedirect (value) {
      this.activeIndex = value;
      this.$router.push(value);
    },
    getNum () {
      return this.num;
    },
  },
};
</script>

<style scoped>
.el-menu--horizontal {
  border: 0px !important;
}
</style>
